<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="profilEmprunteur">
                <ng-container>
                  <div class="formControl mt">
                    <pr-input-radio
                      formControlName="deplacementKilometrique"
                      direction="column"
                      [isDefault]="false"
                      [options]="optionsDeplacementKilometrique"
                      columns="1"
                      [derrors]="derrors"
                      label="Est-ce que vous avez des déplacements kilométriques ?"
                    >
                    </pr-input-radio>
                  </div>
                  <div class="formControl mt">
                    <pr-input-radio
                      formControlName="travailEnHauteur"
                      direction="column"
                      [isDefault]="false"
                      [options]="optionsTravailEnHauteur"
                      columns="1"
                      [derrors]="derrors"
                      label="Est-ce que vous effectuez un travail en hauteur ?"
                    >
                    </pr-input-radio>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer [form]="form" (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
